<template>
  <el-select
    ref="packagetable"
    v-model="selected"
    :placeholder="$t('selecione-uma-opcao')"
    @change="update()"
  >
    <el-option
      v-for="row of packagetable"
      :key="row.id"
      :label="row.name"
      :value="row.id"
    ></el-option>
  </el-select>
</template>

<script>
import { PackageTableService } from "@/services/customers/package.table.services";
export default {
  name: "PackageTableList",
  data: function () {
    return {
      packagetable: [],
      selected: "",
    };
  },
  props: {
    current: String,
  },
  watch: {
    current() {
      const vm = this;
      vm.selected = vm.$props.current;
    },
  },
  methods: {
    fetchPackageTable() {
      const vm = this;
      PackageTableService.list()
        .then((response) => {
          vm.packagetable = response.records;
          setTimeout(() => {
            if (vm.$props.current) {
              vm.selected = vm.$props.current;
            }
          }, 500);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchPackageTable();
  },
};
</script>